import { render, staticRenderFns } from "./PopularBooks.vue?vue&type=template&id=70d973cd"
import script from "./PopularBooks.vue?vue&type=script&lang=js"
export * from "./PopularBooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports